import { Component, Input, ViewEncapsulation } from '@angular/core';
import { JuiButton } from '@jump-tech-frontend/core-components-angular';
import { FormPresenter } from '../../form/form.presenter';
import { FormViewModel } from '../../form/form.view.model';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'help-actions',
  templateUrl: './help-actions.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../actions/actions.component.scss'],
  imports: [JuiButton, ReactiveFormsModule],
  providers: [FormPresenter]
})
export class HelpActionsComponent {
  @Input() vm: FormViewModel;
  constructor(private formPresenter: FormPresenter) {}

  cancelHelp() {
    this.formPresenter.cancelHelp();
  }

  requestHelp() {
    this.formPresenter.submitHelp();
  }
}
